
import OptimizedImage from '@/components/ui/optimized-image';

interface SuccessStoryCardProps {
  logo: string;
  highlight: string;
  description: string;
}

const SuccessStoryCard = ({ logo, highlight, description }: SuccessStoryCardProps) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm shadow-md rounded-lg p-6 transition-transform hover:scale-102 h-full">
      <div className="flex flex-col items-center space-y-4">
        <OptimizedImage
          src={logo}
          alt="Company logo"
          className="h-12 w-auto"
          width={120}
          height={48}
          loading="lazy"
        />
        <h3 className="text-xl font-bold text-cs-dark-grey text-center">
          {highlight}
        </h3>
        <p className="text-cs-medium-grey italic text-center">
          {description}
        </p>
      </div>
    </div>
  );
};

export default SuccessStoryCard;
